import httpClient from '@/lib/httpClient'
import { useMutation } from '@tanstack/react-query'

export default function usePrearchiveVault() {
  const action = async ({ id }: { id: number }) => {
    const response = await httpClient.get(`team/vault/${id}/pre-archive`)
    return response.data.data
  }

  const mutation = useMutation({
    mutationFn: action,
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
